export default "__VITE_ASSET__Bt8uH6d8__"